/**
 * BatonLoader — the agent "thinking" radial metronome animation.
 *
 * 36 batons fan out from the centre; each swings (metronome) + pulses (scaleX),
 * staggered by index, producing a rotating wheat/flower pulse. Recolored to the
 * brand: purple lines, pink end-dots, soft glow. Geometry + keyframes live in
 * index.css (.vv-baton-*); per-arm rotation and animation-delay are inline.
 */
import { useTranslation } from 'react-i18next';

const BATONS = Array.from({ length: 36 }, (_, i) => i);

export function BatonLoader({ className, style }: { className?: string; style?: React.CSSProperties }) {
  const { t } = useTranslation('v2');
  return (
    <div className={className ? `vv-baton-loader ${className}` : 'vv-baton-loader'} style={style} role="status" aria-label={t('batonLoader.loading')}>
      {BATONS.map((i) => (
        <div key={i} className="vv-baton-arm" style={{ transform: `rotate(${i * 10}deg)` }}>
          <div className="vv-baton-metro" style={{ animationDelay: `${-i * 0.14}s` }}>
            <div className="vv-baton" style={{ animationDelay: `${-i * 0.14}s` }} />
          </div>
        </div>
      ))}
      {/* Vivideo play triangle at the centre (logo replica) */}
      <span className="vv-baton-play" aria-hidden="true" />
    </div>
  );
}
